import {useIntl} from 'react-intl';

import {Action, css, Icon, Tooltip} from '@sail/ui';
import {chevronDown, chevronUp} from '@sail/icons/react/Icon';

import {toggleMinimizeButtonMessages} from '../Widget/Header/ToggleMinimizeButtonMessages';

export const assistantHeaderButtonStyles = css({
  display: 'inline-flex',
  borderRadius: 'rounded',
  padding: 'small',
  ':hover': {
    backgroundColor: 'offset',
  },
});

type Props = {
  minimized: boolean;
  onPress: () => void;
};

export function AssistantMinimizeToggleButton({minimized, onPress}: Props) {
  const intl = useIntl();
  const label = intl.formatMessage(
    minimized
      ? toggleMinimizeButtonMessages.open
      : toggleMinimizeButtonMessages.minimize,
  );

  return (
    <Tooltip
      key={minimized ? 'show' : 'hide'}
      type="label"
      placement={minimized ? 'top' : 'bottom'}
      delay={600}
      trigger={
        <Action
          aria-label={label}
          css={{padding: 'small'}}
          onPress={(event) => {
            // The header remains mounted when the widget is minimized. Blur the
            // trigger before changing state so its tooltip cannot follow it.
            (event.target as HTMLElement).blur();
            onPress();
          }}
          uses={[assistantHeaderButtonStyles]}
        >
          <Icon
            data-testid="assistant-header-minimize-button"
            icon={minimized ? chevronUp : chevronDown}
            size="xsmall"
          />
        </Action>
      }
    >
      {label}
    </Tooltip>
  );
}
